import { useState, useEffect } from 'react'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

const usePage = ({ title, breadcrumbs }) => {
  const { dex } = getEnvAndDex()
  const { dexName } = getDexConfig(dex)

  useEffect(() => {
    // No title means the caller does not own the document's — an embedded listing
    // renders inside a page that has already named itself, and setting one here
    // would overwrite that with the more general word.
    if (!title) return
    document.title = `${dexName} Submittals - ${title}`
  }, [dexName, title])

  const [breadcrumbsItems, setBreadcrumbsItems] = useState(breadcrumbs)

  return {
    breadcrumbsItems,
    setBreadcrumbsItems,
  }
}

export default usePage
